import prayvideo from "../../assets/video/praying-video.mp4";
import hibretlogo from "../../assets/images/home/logo.png";
import { useState } from "react"

export default function Header() {

    return (
        <>
            <header className="h-[90vh] relative z-2">
                <nav
                    className="bg-transparent  shadow-none flex  items-center justify-around w-full h-16 fixed top-0 left-0 p-4 bg-transparent shadow-[0_0px_0px_0_rgba(60,64,67,0.2)] z-[15] transition-[0.4s_ease-in-out] block w-100%">
                    <h1 className="p-0 text-[20px] mt-3 p-4 text-base">
                        <a className="flex items-center text-black"><img src={hibretlogo} className="w-10"
                            alt="Hibret for Life" /><span className="flex flex-col font-bold leading-4 text-white"><i>Hibret</i>
                                <i>for Life</i></span></a>
                    </h1>
                    <div>
                        <ul className="flex flex-row text-white">
                            <li className="mr-6">
                                <a className="nav-link colors">About Us</a>
                            </li>
                            <li className="mr-6">
                                <a href="/form.html" id="link2" className="nav-link colora">Prayers & Counseling</a>
                            </li>
                            <li><a href="#team" id="link3" className="nav-link colorb">Team</a></li>
                            <li className="mr-6">
                                <a href="#story" id="link4" className="nav-link colorc">Testimonials</a>
                            </li>
                            <li className="mr-6">
                                <a href="form.html" className="inline-block">Join Us</a>
                            </li>
                        </ul>
                        <div className="hidden">
                            <span className="block w-6 h-1 m-1 m-auto transition-all duration-[0.3s] ease-in-out"></span>
                            <span className="block w-6 h-1 m-1 m-auto transition-all duration-[0.3s] ease-in-out"></span>
                            <span className="block w-6 h-1 m-1 m-auto transition-all duration-[0.3s] ease-in-out"></span>
                        </div>
                    </div>
                </nav>
                <div class="fixed w-full bg-amber-500 top-0 h-16">&nbsp;</div>
                <div
                    className="p-[60px_40px_20px] flex flex-col items-center justify-center text-center h-full text-white z-10 m-[0_auto] relative">
                    <h1 className="text-4xl pb-2 max-w-[700px] transition-[all_0.4s_ease-in-out]">IMPROVING THE SPIRITUAL LIFE OF
                        GOD'S CHILDREN</h1>
                    <p className=" max-w-[600px] text-base font-medium">
                        Click the link below if you need want to , and we'll get back to
                        you as soon as possible. We meet daily by 8pm for counselling and
                        prayers. See you there!
                    </p>
                    <a href="form.html" className="m-[15px_0] p-[10px] font-semibold bg-amber-400">Need Help?</a>
                </div>

                <video className="absolute top-0 left-0 object-cover w-full h-full opacity-100 z-[5]"
                    src={prayvideo} muted autoPlay></video>

                <div className="absolute top-0 left-0 w-full h-full mix-blend-overlay"></div>
            </header>

        </>


    )
}